import type { Dispatch, SetStateAction } from 'react'

import { getRoutinesNames } from '../../../firebase/utils/routines'

import type { RoutineCategory } from './types'
import type { Routines as LegacyRoutineCategory } from '../../../components/users/professors/Students/RoutineSection'
import type { NewLog } from '../../../types'

const toRoutineCategories = (
  routines: LegacyRoutineCategory[] | null,
): RoutineCategory[] | null =>
  routines?.map((routine) => ({
    category: routine.category,
    content: routine.content.map((track) => ({
      ...track,
      routine: track.routine ?? null,
    })),
  })) ?? null

export const loadRoutineCategories = (
  studentLogs: NewLog[],
  onResolved: (routines: RoutineCategory[] | null) => void,
) => {
  const receiveLegacyRoutines: Dispatch<
    SetStateAction<LegacyRoutineCategory[] | null>
  > = (value) => {
    const routines = typeof value === 'function' ? value(null) : value
    onResolved(toRoutineCategories(routines))
  }

  return getRoutinesNames(studentLogs, receiveLegacyRoutines)
}
